module.exports = __webpack_public_path__ + "static/media/3.cd1acc75.jpg";